module.exports = __webpack_public_path__ + "static/media/emotion_happy.cdb9498b.svg";